/**
 * @generated SignedSource<<73fec0f29bd47d090479aa94eda4ef21>>
 * @relayHash afbd1721e739f020ea014993b0519d2b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2c42c3c6df96fe698b1fb138d531e7aeb426917e396813762a3ec27a45cfb0f0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2c42c3c6df96fe698b1fb138d531e7aeb426917e396813762a3ec27a45cfb0f0",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
